import { AppDispatch, RootState } from '..';
import { onAddingCompanyWebsiteRequests, onCompanyWebsiteRequestsUpdate, onDeleteCompanyWebsiteRequests, setCompanyWebsiteRequests } from '../reducers';

import { REACT_APP_MANAGE_SERVICE_ENDPOINT } from '../types';
import axios from 'axios';
import { headers } from '.';
import { notification } from '../../utils';
import { requestCompanyWebsite } from '../../types';

export const getCompanyWebsiteRequest = () => async (dispatch: AppDispatch, getState: RootState) => {

    const { company } = getState().companyReducer;
    const { token } = getState().authReducer;

    const { company_id } = company;

    const { data } = await axios.get(`${REACT_APP_MANAGE_SERVICE_ENDPOINT}/company-website-request/${company_id}`, headers(token));

    const { requests } = data;

    try {

        dispatch(setCompanyWebsiteRequests(requests));
        
    } catch (error: any) {
        console.log(error.message);
    }
};

export const addCompanyWebsiteRequest = (request: requestCompanyWebsite) => async (dispatch: AppDispatch, getState: RootState) => {

    dispatch(onAddingCompanyWebsiteRequests(true));

    const { token } = getState().authReducer;
    const { company } = getState().companyReducer;
    const { company_id } = company;

    const { data } = await axios.post(`${REACT_APP_MANAGE_SERVICE_ENDPOINT}/company-website-request/add`, {...request, company_id}, headers(token));

    try {

        const { success, message } = data;
        notification(success ? 'success' : 'error', message);
        dispatch(onAddingCompanyWebsiteRequests(false));
        
    } catch (error: any) {
        notification('error', error.message);
        dispatch(onAddingCompanyWebsiteRequests(false));
    }
};

export const updateCompanyWebsiteRequest = (request: requestCompanyWebsite) => async (dispatch: AppDispatch, getState: RootState) => {
    
    dispatch(onCompanyWebsiteRequestsUpdate(true));
    
    const { token } = getState().authReducer;

    const { data } = await axios.put(`${REACT_APP_MANAGE_SERVICE_ENDPOINT}/company-website-request/update`, { ...request }, headers(token));

    try {

        const { success, message } = data;
        notification(success ? 'success' : 'error', message);
        dispatch(onCompanyWebsiteRequestsUpdate(false));
        
    } catch (error: any) {
        notification('error', error.message);
        dispatch(onCompanyWebsiteRequestsUpdate(false));
    }
};

export const deleteCompanyWebsiteRequest = (request_id: string) => async (dispatch: AppDispatch, getState: RootState) => {
    
    dispatch(onDeleteCompanyWebsiteRequests(true));
    
    const { token } = getState().authReducer;

    const { data } = await axios.delete(`${REACT_APP_MANAGE_SERVICE_ENDPOINT}/company-website-request/${request_id}/delete`, headers(token));

    try {

        const { success, message } = data;
        notification(success ? 'success' : 'error', message);
        dispatch(onDeleteCompanyWebsiteRequests(false));
        
    } catch (error: any) {
        notification('error', error.message);
        dispatch(onDeleteCompanyWebsiteRequests(false));
    }
};